import React, { useEffect } from "react";
import RemoteConfigService from "./RemoteConfigService";
import ActionTriggerConstants from "./ActionTriggerConstants";
import "./download-landing-lite.css";
import Localize from "./Localize/Localize";
import cookieManager from "./CookieManager";
import UserAgent from "./Utils/UserAgent";
import DeepLinkUtils from "./Utils/DeepLinkUtils";

const DownloadLandingLite = () => {
    useEffect(() => {
        document.body.classList.add("downloadlite-body");
        document.body.style.setProperty("background-color", "transparent", "important");

        return () => {
            document.body.classList.remove("downloadlite-body");
            document.body.style.removeProperty("background-color");
        };
    }, []);
    
    const isEmbedded = UserAgent.isAndroid() && UserAgent.isEmbeddedWebView();
    const downloadButtons = RemoteConfigService.getDownloadButtons() || [];
    
    const getButtonActionName = (opt) => {
        if (
            opt.smallText === "DOWNLOAD_BUTTON_APP_STORE_SMALL" ||
            opt.largeText === "DOWNLOAD_BUTTON_APP_STORE_BIG"
        ) {
            return ActionTriggerConstants.DOWNLOAD_LANDING_APP_STORE_CLICK;
        }

        if (
            opt.smallText === "DOWNLOAD_BUTTON_PLAY_STORE_SMALL" ||
            opt.largeText === "DOWNLOAD_BUTTON_PLAY_STORE_BIG"
        ) {
            return ActionTriggerConstants.DOWNLOAD_LANDING_PLAY_STORE_CLICK;
        }

        if (opt.mediumText === "DOWNLOAD_BUTTON_APK") {
            return ActionTriggerConstants.DOWNLOAD_LANDING_APK_CLICK;
        }

        if (opt.mediumText === "DOWNLOAD_BUTTON_PLAY_NOW") {
            return ActionTriggerConstants.DOWNLOAD_LANDING_PLAY_NOW_CLICK;
        }

        return ActionTriggerConstants.DOWNLOAD_LANDING_BUTTON_CLICK;
    };

    const buildRedirectUrl = (opt, index, link) => {
        const params = new URLSearchParams({
            url: link,
            origin_search: window.location.search || "",
            device_id: cookieManager.getDeviceId(),
            actionName: getButtonActionName(opt),
            buttonIndex: String(index),
            buttonSmallTextKey: opt.smallText || "",
            buttonLargeTextKey: opt.largeText || "",
            buttonMediumTextKey: opt.mediumText || "",
        });

        return `/download-click?${params.toString()}`;
    };

    return (
        <div className="downloadlite-container">
            {downloadButtons
                .filter((opt) => opt.visible)
                .map((opt, index) => {
                    const link = Localize.translate(opt.link);
                    const redirectUrl = buildRedirectUrl(opt, index, link);
                    const finalHref = (() => {
                        if (!isEmbedded) return redirectUrl;
                        const fullUrl = new URL(window.location.origin + redirectUrl);
                        return DeepLinkUtils.openInExternalBrowser(fullUrl.toString());
                    })();

                    return (
                        <a
                            className="download-btn"
                            key={index}
                            href={finalHref}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className="icon">
                                <img
                                    src={opt.icon}
                                    alt="Download icon"
                                    className="icon-img"
                                />
                            </div>

                            <div className="text-container">
                                {opt.smallText && (
                                    <div className="small-text">
                                        {Localize.translate(opt.smallText)}
                                    </div>
                                )}

                                {opt.largeText && (
                                    <div className="large-text">
                                        {Localize.translate(opt.largeText)}
                                    </div>
                                )}

                                {opt.mediumText && (
                                    <div className="medium-text">
                                        {Localize.translate(opt.mediumText)}
                                    </div>
                                )}
                            </div>
                        </a>
                    );
                })}
        </div>
    );
};

export default DownloadLandingLite;